<template>
  <md-icon v-if="isSortable">
    {{ icon }}
  </md-icon>
</template>

<script>
export default {
    name: "MySortControl",
    props: {
      isSortable: Boolean,
      hasBeenSorted: Boolean,
      ascending: Boolean,
    },
    computed: {
        icon() {
            if (!this.hasBeenSorted) {
                return "swap_vert";
            }

            return this.ascending ? "arrow_upward" : "arrow_downward";
        }
    }
};
</script>
